import { render, staticRenderFns } from "./backHome.vue?vue&type=template&id=0ce95f20"
import script from "./backHome.vue?vue&type=script&lang=js"
export * from "./backHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports